var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_c('Error',{attrs:{"error":_vm.getErrorMessage(error),"shouldFadeOut":_vm.shouldFadeOut},on:{"fadeOut":function($event){return _vm.$emit('fadeOut', error)}}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e3a2606","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/modules/shared/betSlip/Errors.vue
// module id = 2000
// module chunks = 0